import { IDetailsComponent } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import styles from './DetailsBlock.module.scss';

type DetailsBlockProps = {
  data: IDetailsComponent
};
const DetailsBlock = ({ data }: DetailsBlockProps) => (
  <section className={classnames(styles.details, 'container')}>
    <h4 className={classnames('title4', styles.title)}>{data.title}</h4>
    <div className={styles.details__content}>
      {data.details.map(item => (
        <div
          className={styles.item}
          key={item.id}
        >
          <div className={styles.item__counter} />
          <div className={styles.item__content}>
            <p className={styles.item__title}>
              .
              {item.title}
            </p>
            <p className={styles.item__text}>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default DetailsBlock;
